var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57354 2.71908L10.1915 2.10117C11.2153 1.07736 12.8752 1.07736 13.899 2.10117C14.9228 3.12497 14.9228 4.78488 13.899 5.80868L13.2811 6.4266M9.57354 2.71908C9.57354 2.71908 9.65078 4.03216 10.8094 5.19076C11.968 6.34936 13.2811 6.4266 13.2811 6.4266M13.2811 6.4266L7.60023 12.1074C7.21546 12.4922 7.02307 12.6846 6.81094 12.85C6.56071 13.0452 6.28996 13.2126 6.00348 13.3491C5.76063 13.4648 5.50251 13.5509 4.98628 13.7229L2.79878 14.4521L2.26406 14.6303C2.01002 14.715 1.72993 14.6489 1.54058 14.4596C1.35123 14.2702 1.28511 13.9901 1.3698 13.7361L1.54803 13.2014L2.2772 11.0139C2.44928 10.4976 2.53532 10.2395 2.65106 9.99666C2.78759 9.71018 2.95492 9.43943 3.15009 9.1892C3.31555 8.97707 3.50794 8.78469 3.89271 8.39991L9.57354 2.71908M2.79878 14.4521L1.54803 13.2014",
    stroke: "#00A991",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.40957024c6da434ddf3caa1f9a160c06.svg";
export { ForwardRef as ReactComponent };